module.exports = "<div class=\"dd-list__list\">\n    <div class=\"js-list-region dd-list__wrp\"></div>\n</div>";